export const getRelativeDay = ({
  baseDate,
  dayAdjustment,
}: {
  baseDate: Date
  dayAdjustment: number
}): Date => {
  return new Date(
    new Date(
      new Date(baseDate).setDate(baseDate.getDate() + dayAdjustment)
    ).setHours(0)
  )
}

export const sameDay = (date: Date, date2: Date): boolean => {
  return (
    date.getFullYear() === date2.getFullYear() &&
    date.getMonth() === date2.getMonth() &&
    date.getDate() === date2.getDate()
  )
}

export const timeslotToLocaleTimeString = (timeslot: Date | string): string => {
  return new Date(timeslot).toLocaleTimeString(`default`, {
    weekday: `short`,
    day: `numeric`,
    month: `long`,
    hour: `numeric`,
    minute: `2-digit`,
    hourCycle: `h12`,
  })
}

export namespace Time {
  export type EpochMilliseconds = number

  export type Milliseconds = number

  export type TimeframeDates = Date[]
}
